
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Button, ButtonGroup, Col, Row } from 'reactstrap'
//import InfoPlacesBody from './infoPlacesBody'
import InfoPlacesDetails from '../../components/NewinfoPlacesDetails'
import InfoPlacesHeader from '../../components/NewinfoPlacesHeader'
import { useTranslation } from 'react-i18next';
import NewinfoPlacesRecomendations from '../../components/NewinfoPlacesRecomendations'
import api from '../../utils/axiosApi'
import './styles.css'
function InfoPlacePreview({
    onClose=()=>{},
    place={},
    shopCarListId= [] ,
    onToggleAct=()=>{},
    onNextAct=()=>{},
    onPrevAct=()=>{},
    onPlacesSelect=()=>{}}) {
    const [tempAct, setTempAct] = useState('')
    
    useEffect(() => {
        var tempActTemp = moment().format('YYYY-MM-DD')
        if(place && place.workingH) {
            const momentDate = moment() 
            const keys = Object.keys(place.workingH).sort((a,b) => {
                const dateA = moment(`${a} 00:00`)
                const dateB = moment(`${b} 00:00`)
                if(dateA > dateB) return -1
                if(dateA < dateB) return 1
                return 0
            })
            let actualTemp = keys.find( date => {
                const mDat = moment(`${date} 00:00`)
                const dife = mDat.diff(momentDate, 'hours', true)
                return dife <= 0
            })
            if (!actualTemp) { actualTemp = keys[keys.length - 1]}
            tempActTemp = actualTemp
        }
        if(place){
            api.post('/metrics/setMetric',{
                type:'ActivityRequest',
                urlDestiny:place.name,
                value:place?._id
            })
            api.put(`/adminsplaces/updateViewCount?placeId=${place?._id}`)
        }
        setTempAct(tempActTemp)
        return () => {
            
        }
    }, [place])
    const { /*t,*/i18n } = useTranslation();
    //const descripcion = i18n.language==='es' ? place?.descriptionLarge: place?.descriptionEn
    const cityname = i18n.language==='es' ? `${place.location?.[0].city}, ${place.location?.[0].country}`: `${place.location?.[0].cityEn}, ${place.location?.[0].countryEn}`
    
    const url = `https://www.google.com/maps/@${place?.lat},${place?.lon},50m/data=!3m1!1e3`
    debugger
    return (
        <>
        <div className='totalPopUpUpperCont dashboardinfoPop position-fixed' style={{zIndex:6000}}>
            <ButtonGroup className='btnContinerActivities'>
            <Button onClick={onPrevAct} className='btnNextAct'>prev</Button>
            <Button onClick={onClose} color="danger" className='btnNextAct'>cerrar</Button>
            <Button onClick={onNextAct} className='btnNextAct'>sig</Button>
            </ButtonGroup>
            
            <div className='NewInfoPopSearchCont animate__animated animate__zoomIn animate__faster' >
                <div className='NewInfoPopSearchImg' style={{
                backgroundImage: `url('${place?.urlImg}')`
                }}>

                    <div className='NewInfoPopSearchWhite'>
                        <InfoPlacesHeader
                            url={url}
                            cityEmoji={place.location?.[0].emoji}
                            cityName={cityname}
                            selected={shopCarListId.includes(place?._id)}
                            urlBack={place?.urlImg}
                            title={i18n.language==='es' ? place?.name: place?.nameEn}
                            stars={place?.stars}
                            textBtn={'Editar actividad'}
                            onToggleAct={()=>{onToggleAct(place)}}
                            onClose={onClose}    
                        > </InfoPlacesHeader>
                        <Row className='InfoPlacesBodyCont mt-4 flex-column-reverse flex-md-row'>
                            <Col md='6' lg='5'>
                                <NewinfoPlacesRecomendations
                                placeCoor={
                                    {lat: place.lat,lon: place.lon,}
                                }
                                onPlacesSelect={onPlacesSelect}
                                >

                                </NewinfoPlacesRecomendations>
                                {/* <div className={`longDescription text-justify`}>
                                    
                                    <p className='m-0 w-100'>
                                    {descripcion }
                                    </p>
                                </div> */}
                            </Col>
                            
                            <Col md='6' lg='7'>
                            <InfoPlacesDetails
                            url={url}
                            tempAct={tempAct}
                            place={place}>
                            </InfoPlacesDetails>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
            
        </div>
        <div onClick={() => {onClose()}} style={{backgroundColor:'transparent'}} className='backgroundPopUp position-fixed'></div>
            
        </>
    )
}

export default React.memo(InfoPlacePreview)
/*
const place ={
    "_id": "6239fadf368c138576111e6f",
    "name": "Bar restaurant Los Alegres",
    "nameEn": "Bar restaurant Los Alegres",
    "place": "F3XG+V5F, Caracas 1020, Capital District, Venezuela",
    "location": [
        {
            "_id": "6145e78f8f85580cdc426d6d",
            "city": "Caracas",
            "state": "Distrito Capital",
            "country": "Venezuela",
            "fullName": "Caracas, Distrito Capital, Venezuela",
            "emoji": {
                "emoji": "🇻🇪",
                "url": "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/1f1fb-1f1ea.png"
            },
            "createdAt": "2021-09-18T13:20:15.994Z",
            "updatedAt": "2022-03-21T19:00:35.880Z",
            "__v": 0,
            "cityEn": "CaracasEn",
            "countryEn": "VenezuelaEn",
            "fullNameEn": "CaracasEn, Distrito Capital, VenezuelaEn",
            "stateEn": "Distrito Capital",
            "lat": 10.506098,
            "lon": -66.914602,
            "priceTypeDefault": "Bs",
            "radius": 1500
        }
    ],
    "stars": "5",
    "duration": 1,
    "workingH": {
        "2022-03-22": {
            "1_7": {
                "start": "07:30",
                "end": "21:00"
            }
        }
    },
    "tags": [
        "restaurant",
        "food",
        "point_of_interest",
        "establishment",
        "googleplace",
        "venezuela",
        "distrito capital"
    ],
    "classes": "color-8",
    "lat": 10.4996994,
    "lon": -66.9245873,
    "urlImg": "https://res.cloudinary.com/tripendar-com/image/upload/v1647975143/tqeuahqeb7ooonnavkd8.jpg",
    "idImg": "tqeuahqeb7ooonnavkd8",
    "web": "",
    "mail": "",
    "telf": "",
    "descriptionLarge": "",
    "descriptionEn": "",
    "title": "Recomendación de Google Places",
    "titleEn": "Google Places Recommendation",
    "GoogleActivite": "ChIJ7fpv-oJfKowR9k757MaiwoE",
    "createdAt": "2022-03-22T16:35:43.835Z",
    "updatedAt": "2022-03-22T18:52:23.698Z",
    "__v": 0
}
*/